import { render } from "./successModal.vue?vue&type=template&id=03687943&ts=true"
import script from "./successModal.vue?vue&type=script&lang=ts"
export * from "./successModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__